import { Body1 } from "@iventis/styles/src/components/texts";
import { Content } from "@iventis/translations/content/typed-content";
import React from "react";
import { styled } from "@iventis/styles";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { ConfirmationDialogComponent } from "@iventis/components";

export const RestoreInhertianceModal: React.FC<{ open: boolean; onClose: () => void; onConfirm: () => void }> = ({ open, onClose, onConfirm }) => {
    const translate = useIventisTranslate();

    return (
        <ConfirmationDialogComponent
            dataCy="permission-inheritance-on-confirm"
            show={open}
            title={translate(Content.permissions.turnOnInheritance)}
            confirmText={translate(Content.permissions.turnOnInheritance)}
            cancelText={translate(Content.common.buttons.cancel)}
            handleCancel={onClose}
            handleConfirm={onConfirm}
        >
            <StyledDescription>{translate(Content.permissions.turnOnInheritanceDescription1)}</StyledDescription>
            <StyledDescription>{translate(Content.permissions.turnOnInheritanceDescription2)}</StyledDescription>
            <StyledDescription>{translate(Content.permissions.inheritanceChangesSaved)}</StyledDescription>
        </ConfirmationDialogComponent>
    );
};
const StyledDescription = styled(Body1)`
    padding-top: 5px;
    padding-bottom: 5px;
`;
